<template>
    <SearchResultsPanel
        :title="title"
        @viewAll="viewAll"
        :showViewAll="showViewAll"
        :showCount="showCount"
        :count="companies.meta.resultCount"
    >
        <ul>
            <li v-for="company in displayCompanies" :key="company.id" class="search-result">
                <router-link
                    :to="{ name: 'company-page', params: { id: company.id } }"
                    @click.native.capture="event => $emit('navigating', event, company)"
                >
                    <CompanyBadge :company="company" size="medium" symbol hide-popover />
                </router-link>
                <div class="button-group">
                    <WatchlistButton entity-type="Company" :entity-id="company.id" class="small" />
                </div>
            </li>
        </ul>
    </SearchResultsPanel>
</template>
<script setup>
import { computed } from 'vue'
import CompanyBadge from '../companies/CompanyBadge.vue'
import SearchResultsPanel from './SearchResultsPanel.vue'
import WatchlistButton from '@/components/shared/watchlist-button'

const props = defineProps({
    companies: {
        type: Object,
        required: true,
    },
    maxItems: {
        type: Number,
        required: true,
    },
    showCount: {
        type: Boolean,
        default: true,
    },
    showViewAll: {
        type: Boolean,
        required: true,
    },
    title: {
        type: String,
        default: 'Company Results',
    },
})

const emit = defineEmits(['viewAll'])

const displayCompanies = computed(() => props.companies.results.map(i => i.entity).slice(0, props.maxItems))

function viewAll() {
    emit('viewAll')
}
</script>
<style scoped>
ul {
    display: flex;
    flex-direction: column;
}

li {
    display: flex;
    flex-direction: row;
}

li > a {
    flex-grow: 1;
}

li > .button-group {
    flex-shrink: 0;
}
</style>
